import React, {useState, useEffect} from "react"
import Tab1 from "./tabs/Tab1"
import Tab2 from "./tabs/Tab2"
import Tab3 from "./tabs/Tab3"
import Tab4 from "./tabs/Tab4"
import "./form-wizard.css"

const UserFormWizard = ({tab, setTab, data, isLoading, submitData}) => {

    const [userData, setUserData] = useState(data??{});

    /* Data holder */
    const addTabData = data => {
        setUserData({...userData, ...data});
    }

    /* Clear fields on success */
    useEffect(() => {
        if (tab === 0 || tab > 4){
            setTab(1)
        }
    });

    /* Auto scroll to top on new tab */
    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
      }, [tab])

    return <div className="container">
                <div className="card card-custom card-transparent" id="user-wizard">
                    <div className="card-body p-0">
                        {/* <!--begin: Wizard--> */}
                        <div className="wizard wizard-4" id="kt_wizard" data-wizard-state="step-first" data-wizard-clickable="true">
                            {/* <!--begin: Wizard Nav--> */}
                            <div className="wizard-nav">
                                <div className="wizard-steps">
                                    {/* <!--begin::Wizard Step 1 Nav--> */}
                                    <div 
                                        className="wizard-step" 
                                        data-wizard-type="step" 
                                        data-wizard-state={tab === 1 ? "current" : ""}
                                        onClick={_=> setTab(1)}
                                    >
                                        <div className="wizard-wrapper">
                                            <div className="wizard-number">1</div>
                                            <div className="wizard-label">
                                                <div className="wizard-title">User Account</div>
                                                <div className="wizard-desc">Basic Information</div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--end::Wizard Step 1 Nav--> */}
                                    {/* <!--begin::Wizard Step 2 Nav--> */}
                                    <div
                                        className="wizard-step" 
                                        data-wizard-type="step" 
                                        data-wizard-state={tab === 2 ? "current" : ""}
                                        onClick={_=> setTab(2)}
                                    >
                                        <div className="wizard-wrapper">
                                            <div className="wizard-number">2</div>
                                            <div className="wizard-label">
                                                <div className="wizard-title">Personal Data</div>
                                                <div className="wizard-desc">Profile Information</div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--end::Wizard Step 2 Nav--> */}
                                    {/* <!--begin::Wizard Step 3 Nav--> */}
                                    <div
                                        className="wizard-step" 
                                        data-wizard-type="step" 
                                        data-wizard-state={tab === 3 ? "current" : ""}
                                        onClick={_=> setTab(3)}
                                    >
                                        <div className="wizard-wrapper">
                                            <div className="wizard-number">3</div>
                                            <div className="wizard-label">
                                                <div className="wizard-title">Compliance Data</div>
                                                <div className="wizard-desc">User Funding Details</div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--end::Wizard Step 3 Nav--> */}
                                    {/* <!--begin::Wizard Step 4 Nav--> */}
                                    <div
                                        className="wizard-step" 
                                        data-wizard-type="step" 
                                        data-wizard-state={tab === 4 ? "current" : ""}
                                        onClick={_=> setTab(4)}
                                    >
                                        <div className="wizard-wrapper">
                                            <div className="wizard-number">4</div>
                                            <div className="wizard-label">
                                                <div className="wizard-title">Completed</div>
                                                <div className="wizard-desc">Review and Submit</div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--end::Wizard Step 4 Nav--> */}
                                </div>
                            </div>
                            {/* <!--end: Wizard Nav--> */}
                            {/* <!--begin: Wizard Body--> */}
                            <div className="card card-custom card-shadowless rounded-top-0">
                                <div className="card-body p-0">
                                    <div className="row justify-content-center py-8 px-8 py-lg-15 px-lg-10">
                                        <div className="col-xl-12 col-xxl-8">
                                                
                                            <Tab1 tab={tab} setTab={setTab} userData={userData} addTabData={addTabData} />
                                            <Tab2 tab={tab} setTab={setTab} userData={userData} addTabData={addTabData} />
                                            <Tab3 tab={tab} setTab={setTab} userData={userData} addTabData={addTabData} />
                                            <Tab4 tab={tab} setTab={setTab} userData={userData} isLoading={isLoading} submitData={submitData}/>
                                                
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end: Wizard Bpdy--> */}
                        </div>
                        {/* <!--end: Wizard--> */}
                    </div>
                </div>
            </div>
            // <!--end::Container-->

}

export default UserFormWizard;